import React from 'react';
import {Link} from 'react-router-dom';

const BudgetLink = ({ budget, selectedBudget, onClick }) => {
	const handleClick = () => {
    onClick(budget.id);
	}
	
	const dest = "/calculator/" + budget.id + "/";

  return (
		<li className={selectedBudget === budget.id ? "active" : ""}>
			<Link onClick={handleClick} to={dest}>
				<img src={budget.image} alt={budget.title} />
				<h2>{budget.title}</h2>
			
			</Link>
		</li>
	)

}
export default BudgetLink;


// WEBPACK FOOTER //
// ./src/components/calculator/BudgetLink.js